import React from 'react';
import Pb from '../Pb';
type Props = {};

const PbContainer = (props: Props) => {
  return <Pb />;
};

export default PbContainer;
